// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"de09746a","666":"deb5cd84"}[chunkId] + ".chunk.js";
};